import { useItem } from '@/composables/item'
import { craftsmanTaskService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useCraftsmanTaskStore = defineStore('craftsmanTask', () => {
	const { items, show, create, detach, update, getItem } = useItem<
		Api.CraftsmanTaskStatusText,
		Api.CraftsmanTaskStatusTextPostInput,
		Api.CraftsmanTaskStatusTextUpdateInput
	>(craftsmanTaskService, 'craftsman_tasks', 'CraftsmanTask', {
		options: { itemRemove: false },
	})
	return {
		items,
		show,
		create,
		detach,
		update,
		getItem,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(
		acceptHMRUpdate(useCraftsmanTaskStore, import.meta.hot)
	)
}
